import { useState } from 'react'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Collapse from '@mui/material/Collapse'
import Typography from '@mui/material/Typography'

// The short version of both rows, folded until asked for. A line each; the
// detail is in each stage's popup, and README.md has the rest.
const POINTS = [
  [
    'Top row',
    'audio in, quotes out. Phones record in one-minute segments, grouped into spans. Once a span is safe here, we find the speech, transcribe it and pick quotes.',
  ],
  [
    'Bottom row',
    'what happens to a quote. A push tells its owner, they open the app and listen, and friends hear it too.',
  ],
  [
    'Colour',
    'green is fine, amber is worth a look, red means something was lost.',
  ],
  ['Moving dashes', 'what happened since the last refresh, every minute.'],
  ['Time on a pipe', 'how long that step usually takes, over the window.'],
  [
    'Dotted and dashed',
    'dotted is measuring only, nothing held back. Dashed grey is not built yet.',
  ],
]

const HowThisWorks = () => {
  const [explain, setExplain] = useState(false)
  return (
    <Box>
      <Button
        size="small"
        onClick={() => setExplain((open) => !open)}
        sx={{ textTransform: 'none', px: 0 }}
      >
        {explain ? 'Hide' : 'How this works'}
      </Button>
      <Collapse in={explain}>
        <Box component="ul" sx={{ mt: 1, mb: 0, pl: 2.5, maxWidth: 720 }}>
          {POINTS.map(([term, text]) => (
            <Typography
              key={term}
              component="li"
              variant="body2"
              color="text.secondary"
              sx={{ mb: 0.5 }}
            >
              <b>{term}:</b> {text}
            </Typography>
          ))}
        </Box>
      </Collapse>
    </Box>
  )
}

export default HowThisWorks
